import Error from './src/ErrorMessage.vue';
import {ref} from "vue";

const useError = () => {
	const errors = ref({});

	const addError = (key, error) => {
		if (!(key in errors.value)) {
			errors.value[key] = [];
		}

		errors.value[key].push(error);
	};

	const getErrors = (key) => {
		return key in errors.value ? errors.value[key] : [];
	};

	const clearError = (key) => {
		delete errors.value[key];
	};

	const clearErrors = () => {
		errors.value = {};
	};

	const hasErrors = () => {
		return Object.keys(errors.value).length > 0;
	}

	return { errors, addError, getErrors, hasErrors, clearError, clearErrors };
}

export { Error, useError };